import {Line} from "@react-three/drei";
import {useMemo} from "react";
import type {Dimensions} from "../Scene.tsx";

type PlaneProps = {
    dimensions: Dimensions;
    color?: string;
    lineWidth?: number;
    yPosition: number | null;
}

export function Plane({dimensions, lineWidth = 1, color = "#fff", yPosition}: PlaneProps) {
    if (!yPosition) return null;

    const {width, depth} = dimensions;

     // Edges of the plane (4 edges forming a rectangle)
    const planeEdges = useMemo(() => {
        const w = width / 2;
        const d = depth;

        // 4 corners of the plane
        const v0: [number, number, number] = [-w, yPosition, 0];
        const v1: [number, number, number] = [w, yPosition, 0];
        const v2: [number, number, number] = [w, yPosition, -d];
        const v3: [number, number, number] = [-w, yPosition, -d];

        return [
            [v0, v1], [v1, v2], [v2, v3], [v3, v0]
        ] as [[number, number, number], [number, number, number]][];
    }, [width, depth, yPosition]);

    return (
        <>
            {/* Thin horizontal plane mesh */}
            <mesh position={[0, yPosition, -depth/2]}>
                <boxGeometry args={[width, 0.002, depth]}/>
                <meshStandardMaterial
                    color={color}
                    transparent
                    opacity={0.2}
                    depthWrite={false}
                />
            </mesh>
            {/* Plane edges */}
            {planeEdges.map((edge, i) => (
                <Line
                    key={i}
                    points={edge}
                    color={color}
                    lineWidth={lineWidth}
                />
            ))}
        </>
    );
}

